import { TagColor } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { PayrollStatus } from 'modules/payroll_bundle/lib/enums'

export const tagColor: (status: string) => TagColor = (status) => {
  switch (status) {
    case PayrollStatus.PAYROLL_CALCULATION:
      return TagColor.radical
    case PayrollStatus.PAYMENT_PROCESSING:
    case PayrollStatus.PAID:
      return TagColor.lime
    default:
      return TagColor.malibu
  }
}

export const statusModifier = (status: string): string => {
  switch (status) {
    case PayrollStatus.PAYROLL_CALCULATION:
      return i18n.t('bookkeepers.clients.payroll_periods.payroll_calculation')
    case PayrollStatus.PAYMENT_PROCESSING:
    case PayrollStatus.PAID:
      return i18n.t('bookkeepers.clients.payroll_periods.payment')
    default:
      return i18n.t('bookkeepers.clients.payroll_periods.defining_supplements')
  }
}
